import { PRIVATE_FOLDER_OWNER_MISMATCH_ERROR_CODE } from "@zapier/utils";

export interface PrivateFolderOwnerMismatch {
  folderOwnerId: number;
  assets: Array<{ type: string; id: string }>;
}

/**
 * Reads the owner mismatch the BFF attaches to a refused move. Returns
 * undefined for every other error.
 */
export function getPrivateFolderOwnerMismatch(
  error: unknown,
): PrivateFolderOwnerMismatch | undefined {
  const data = (error as { data?: Record<string, unknown> } | null)?.data;
  if (!data || data.code !== PRIVATE_FOLDER_OWNER_MISMATCH_ERROR_CODE) {
    return undefined;
  }
  if (typeof data.folderOwnerId !== "number" || !Array.isArray(data.assets)) {
    return undefined;
  }
  return {
    folderOwnerId: data.folderOwnerId,
    assets: data.assets as PrivateFolderOwnerMismatch["assets"],
  };
}
